
export { SamImageProcessor as Sam2ImageProcessor } from '../sam/image_processing_sam.js';
